// extracted by mini-css-extract-plugin
export var content = "NoPermissionsPage-module--content--ac11e";
export var image = "NoPermissionsPage-module--image--b7fb0";
export var inner = "NoPermissionsPage-module--inner--2c714";
export var orikamiImage = "NoPermissionsPage-module--orikami-image--c4c8a";